import React, {Component} from 'react';

import axios from 'axios';
import auth0Client from '../Auth';
import { VictoryBar, VictoryChart, VictoryLabel, VictoryAxis } from 'victory';
import {ToastContainer, ToastStore} from 'react-toasts';
import {  Link, withRouter } from "react-router-dom";
//import Claims from '../Claims/Claims';
import {SERVER_URL}  from '../Constants';
import ClaimFormatterFunctions from '../Claims/ClaimFormatters';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import LostItemFunctions from '../LostItem/LostItemFunctions';
import BounteBoxImporter from '../Box/BoxImporter2';
import Modal from 'react-responsive-modal';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import paginationFactory from 'react-bootstrap-table2-paginator';
/*const claimColumns = [
  { dataField: 'id', hidden:true, text: 'id',headerAlign:'center', headerStyle: (colum, colIndex) => {return { width: '50px', textAlign: 'left' };}},
  { dataField: 'lastName', text: 'Name', headerAlign:'center',classes:'text-info', sort: true,formatter: formatName, textAlign: 'left'},
  { dataField: 'status', text: 'Stage',headerAlign:'center',classes:ClaimFormatterFunctions.statusColFormaterClaims, formatter:ClaimFormatterFunctions.stageFormatter, filterable:true, sort: true, textAlign: 'left' },
  { dataField: 'claimDate', text: 'Claim Date',headerAlign:'center',formatter:ClaimFormatterFunctions.formatDate, sort: true, headerStyle: (colum, colIndex) => {return { width: '150px', textAlign: 'center' };} },
  { dataField: 'lostItemShortDescription', headerAlign:'center', text: 'linked Item',sort: true, },
  { dataField: 'topMatchPct', classes:'text-primary text-center',formatter:formatMatched, text: 'Matched',sort: true,headerStyle:{width:'150px'}, events:{
      onClick: (e, column, columnIndex, row, rowIndex) => {
            if (row.topMatchPct && row.topMatchPct > 0){
              window.location = '/AIM/';
            }
      }}},
];*/




const claimStadiumColumns = [
  { dataField: 'id', hidden:true, text: 'id', headerStyle: (colum, colIndex) => {return { width: '50px', textAlign: 'left' };}},
  { dataField: 'lastName', text: 'Name', classes:'text-primary', sort: true,formatter: ClaimFormatterFunctions.nameFormatter, textAlign: 'left'},
  { dataField: 'status', text: 'Stage',classes:ClaimFormatterFunctions.statusColFormaterClaims, formatter:ClaimFormatterFunctions.stageFormatter, filterable:true, sort: true, textAlign: 'left' },
  { dataField: 'claimDate', text: 'Claim Date',formatter:ClaimFormatterFunctions.formatDate, sort: true, headerStyle: (colum, colIndex) => {return { width: '120px', textAlign: 'center' };} },
  { dataField: 'details', text: 'Details',sort: true, },
  { dataField: 'section',sort: true, classes:'text-primary', text: 'section',  headerStyle: (colum, colIndex) => {return { width: '90px', textAlign: 'center' };}},
  { dataField: 'row',sort: true, classes:'text-primary', text: 'row',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center' };}},
  { dataField: 'seat',sort: true, classes:'text-primary', text: 'Seat',  headerStyle: (colum, colIndex) => {return { width: '90px', textAlign: 'center' };}},
  { dataField: 'parkingLot',sort: true, classes:'text-primary', text: 'parkingLot',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center' };}},

];


const lostItemColumns = [
  { dataField: 'itemNumber', sort: true,classes:'text-primary',style:{cursor: 'pointer'}, headerAlign:'center', text: 'Item#', filterable:true,  textAlign: 'left', headerStyle: {width:'70px'} },
  { dataField: 'shortDescription', sort: true,classes:'text-info', style:{cursor: 'pointer'}, headerAlign:'center',text: 'Item',  formatter:formatShortAndLong, filterable:true,  textAlign: 'left' },
  { dataField: 'itemState', sort: true,headerAlign:'center',style:{cursor: 'pointer'}, formatter: formatItemStatusCell, text: 'Status Code',  textAlign: 'left'},
  { dataField: 'longDescription',sort: true, text: 'Description',style:{cursor: 'pointer'},  headerAlign:'center', textAlign: 'left'},
  { dataField: 'foundDate',sort: true,formatter: LostItemFunctions.formatDate,style:{cursor: 'pointer'},  headerAlign:'center', text: 'Found',  headerStyle: (colum, colIndex) => {return { width: '120px', textAlign: 'center' };}},
  { dataField: 'locationName',sort: true, text: 'Found Near',style:{cursor: 'pointer'},  headerAlign:'center', textAlign: 'left'},
];
const lostItemReleasePendingColumns = [
  { dataField: 'itemNumber', sort: true,classes:'text-primary',style:{cursor: 'pointer'}, headerAlign:'center', text: 'Item#', filterable:true,  textAlign: 'left', headerStyle: {width:'70px'} },
  { dataField: 'shortDescription', sort: true,classes:'text-info', style:{cursor: 'pointer'}, headerAlign:'center',text: 'Item',  formatter:formatShortAndLong, filterable:true,  textAlign: 'left' },
  { dataField: 'itemState', sort: true,headerAlign:'center',style:{cursor: 'pointer'}, formatter: formatItemStatusCell, text: 'Status Code',  textAlign: 'left'},
  { dataField: 'foundDate',sort: true,formatter: LostItemFunctions.formatDate,style:{cursor: 'pointer'},  headerAlign:'center', text: 'Found',  headerStyle: (colum, colIndex) => {return { width: '120px', textAlign: 'center' };}},
  { dataField: 'releaseDate',sort: true,formatter: LostItemFunctions.formatDate,style:{cursor: 'pointer'},  headerAlign:'center', text: 'Release Dt.',  headerStyle: (colum, colIndex) => {return { width: '120px', textAlign: 'center' };}},
 ];

//STADIUM
const stadiumColumns = [
  { dataField: 'itemNumber',classes:'text-primary', sort: true, text: 'Item#', filterable:true,  textAlign: 'left', headerStyle: {width:'50px'}},
  { dataField: 'shortDescription',classes:'text-primary', sort: true, text: 'Item', filterable:true,  textAlign: 'left', headerStyle: {width:'200px'}},
  { dataField: 'itemState', sort: true,classes:LostItemFunctions.statusColFormater, formatter: LostItemFunctions.itemStatusDesc, text: 'Status Code', width: '100px', textAlign: 'left'},
  { dataField: 'longDescription',sort: true, text: 'Description',  textAlign: 'left', classes:'text-primary',headerStyle: (colum, colIndex) => { return {  textAlign: 'center' };}},
  { dataField: 'section',sort: true, classes:'text-primary', text: 'section',  headerStyle: (colum, colIndex) => {return { width: '90px', textAlign: 'center' };}},
  { dataField: 'row',sort: true, classes:'text-primary', text: 'row',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center' };}},
  { dataField: 'seat',sort: true, classes:'text-primary', text: 'Seat',  headerStyle: (colum, colIndex) => {return { width: '90px', textAlign: 'center' };}},
  { dataField: 'parkingLot',sort: true, classes:'text-primary', text: 'parkingLot',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center' };}},
  { dataField: 'gate',sort: true, classes:'text-primary', text: 'Gate / Lounge',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center' };}},
  { dataField: 'foundDate',sort: true,formatter: LostItemFunctions.formatDateTime, classes:'text-primary', text: 'Found',  headerStyle: (colum, colIndex) => {return { width: '190px', textAlign: 'center' };}},
];

const defaultSorted = [{
  dataField: 'foundDate',
  order: 'asc'
}];
const paginationOption = {
  custom: true,
  sizePerPage: 10
};

function formatItemStatusCell(cell,row){
  let statusText= LostItemFunctions.itemStatusDesc(row.itemState);
  if (row.itemState==='C' || row.itemState==='R'){
      return(<span className="text-success"><b>{statusText}</b></span>);
  }else if(row.itemState==='Q'){
      return(<span className="text-info"><b>{statusText}</b></span>);
  }else{
      return(<span className="text-primary"><b>{statusText}</b></span>);
  }
};


function formatMatched(cell,row){
  try{
    if(row.totalMatches && row.totalMatches >0){
      return (<button style={{color:'#1f9bcf'}} className="btn btn-link-info btn-sm" type="button">{row.totalMatches} Matche(s)</button>)

    }else{
      return(null)
    }
    
  }catch(e){

  }
}




function formatName(cell, row){

  
  if (cell){
    return (
     
       <a href='#/'><div className='text-left text-info'><b>{row.lastName + ', ' + row.firstName} </b></div></a> 
     
    )
  }
}
function formatShortAndLong(cell, row){
  if (cell){
    return (
      <b>{row.shortDescription} </b>
    )
  }
}

class Dashboard extends Component {
  constructor(props) {
    super(props);

   

    const LostItemfillColor = "#23395B" ;
    const claimFillColor=  "#406E8E";
    // Column headers for the claims grid
  
    this.state = {
      questions: null,
      openClaims: 0,
      readyToShip:0,
      readyForPickup:0,
      numUnlinkedItems:0,
      numReturned:0,
      lostItemSummaryData:[],
      lostItemPieData : [],
      claimsSummaryData:[],
      claimsPieData : [],
      matchedItemsData:[],
      matchedItemCount:0,
      bounteBoxItems:[],
      bounteBoxItemsCount:0,
      bounteBoxLoadingIndicator: false,
      hasBounteBoxActive :false,
      showBounteBoxImporter: false,
      claimStyle: {
        data: { fill: claimFillColor }
      },
      lostStyle: {
        data: { fill: LostItemfillColor }
      },
      recentOpenClaims : [],
      recentLostItems : [],
      venueTypeCd: '',
      pastDueReleaseDateItems:[],
      claimSummaryStatus:[],
      lostItemStatusSummary:[],
      RequestToShipCount:0,
      displayReleaseDateOnDashboard:false,

    };
    this.claimRowEvents = {
      onClick: (e, row, rowIndex) => {
        if (e.target.type==='button' && e.target.textContent==='View Item') {
          this.props.history.push('/LostItem/' + row.lostItemId );
          return;
        }
        if (e.target.type==='button') {
          this.props.history.push('/AIM/' + row.id );
          return;
        }
        this.props.history.push('/Claim/' + row.id);

      },
      
    };

    
    this.rowLostItemEvents = {
      onClick: (e, row, rowIndex) => {
        
        this.props.history.push('/LostItem/' + row.id);
        //console.log(this + ' ' + `clicked on row with index: ${rowIndex}`);
        
    
      },
      
    };

  }


  getColumns=(venueTypeCd)=>{
    if (venueTypeCd==='A'){
     //return airlineColumns;
     return lostItemColumns
    }else if (venueTypeCd==='S'){
     return stadiumColumns;
    }else{
      return lostItemColumns;
    }
  }
  getClaimColumns=(venueTypeCd)=>{
    if (venueTypeCd==='A'){
      return this.claimColumns();
    }else if (venueTypeCd==='S'){
     return claimStadiumColumns;
    }else{
      return this.claimColumns();
    }
  }

  async componentDidMount() {

    // set venueTypeCode
    this.setState({
      venueTypeCd: auth0Client.getDefaultVenue().venueTypeCd,
      hasBounteBoxActive:auth0Client.getDefaultVenue().boxEnabled,
      displayReleaseDateOnDashboard:auth0Client.getDefaultVenue().displayReleaseDateOnDashboard
    })

    this.loadDashBoardData();
    this.loadBounteBoxData();

  }

  loadBounteBoxData= async()=>{
    axios.post(`${SERVER_URL}/box/queryboxitems/`,
    {
      statusCd : 'Q'
    },
    {
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId' : auth0Client.getActiveVenuedId()
     }
    }).then((res)=>{
      if (res.status !== 200) {
        //place your reentry code
        console.log(res);
        ToastStore.error("An error occured. Please try again :" + res.body);
       
       }else{
          this.setState({
            bounteBoxItems :res.data,
            bounteBoxItemsCount: (res.data)?res.data.length : 0
          });
    }
    })
  }

  loadDashBoardData =()=>{
    
   
    
    axios.get(`${SERVER_URL}/Dashboard/`,{
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId' : auth0Client.getActiveVenuedId()
     }
    }).then((res)=>{

      if (res.status !== 200) {
        //place your reentry code
        console.log(res);
        ToastStore.error("An error occured. Please try again :" + res.body);
       
       }else{
          const dashboardDto = res.data;
          this.setState({
            recentOpenClaims : dashboardDto.recentOpenClaims,
            recentLostItems: dashboardDto.recentLostItems,
            matchedItemsData:dashboardDto.matches,
            matchedItemCount: (dashboardDto.matchCount),
            pastDueReleaseDateItems:dashboardDto.pastDueReleaseDateItems,
            claimSummaryStatus:dashboardDto.claimSummaryStatus,
            lostItemStatusSummary:dashboardDto.lostItemStatusSummary

          });
          this.updateChartsTotals(dashboardDto.claimSummaryStatus, dashboardDto.lostItemStatusSummary);
        }
    })

  }

  updateChartsTotals=(claimSummary, lostItemSummary)=>{

    var claimsChartData = [];
    
    if (claimSummary && claimSummary.length > 0){

      var openClaims =  (claimSummary.find(c => c._id === 'O')) ? (claimSummary.find(c => c._id === 'O')).count : 0;
      var readyForPickup=(claimSummary.find(c => c._id === 'WP')) ? (claimSummary.find(c => c._id === 'WP')).count : 0;
      var readyToShip = (claimSummary.find(c => c._id === 'READYTOSHIP')) ? (claimSummary.find(c => c._id === 'READYTOSHIP')).count : 0;
      var RequestToShip= (claimSummary.find(c => c._id === 'REQUESTTOSHIP')) ? (claimSummary.find(c => c._id === 'REQUESTTOSHIP')).count : 0;

      claimsChartData.push(
          {
          x : 'Open',
          y: openClaims,
          fill: "#1F9BCF", width:5,
          },
          {
          x : 'Ready to Ship',
          y: readyToShip,
          fill: '#f0ad4e', width:5
          },
          {
          x : 'Label Requested',
          y: (claimSummary.find(c => c._id === 'LABELREQUESTED')) ? (claimSummary.find(c => c._id === 'LABELREQUESTED')).count : 0,
          fill: '#f0ad4e', width:5
          },

          {
          x : 'Will Pickup',
          y: readyForPickup,
          fill: '#f0ad4e', width:5
          },
          {
          x : 'Shipped',
          y: (claimSummary.find(c => c._id === 'CS')) ? (claimSummary.find(c => c._id === 'CS')).count : 0,
          fill: '#4BBF73', width:5

          },
          {
            x : 'Picked Up',
            y: (claimSummary.find(c => c._id === 'CP')) ? (claimSummary.find(c => c._id === 'CP')).count : 0,
            fill: '#4BBF73', width:5
            },
            {
              x : 'Request To Ship',
              y: RequestToShip,
              fill: '#4BBF73', width:5
              }

        );  
    
    }

    var lostItemChartData = [];
    var lostItemPieData = [];
     var totalReturned = 0;
    var openLostItems = 0;


    if (lostItemSummary && lostItemSummary.length > 0){
        totalReturned= (lostItemSummary.find(c => c._id === 'R')) ? (lostItemSummary.find(c => c._id === 'R')).count : 0;
        openLostItems= (lostItemSummary.find(c => c._id === 'Q')) ? (lostItemSummary.find(c => c._id === 'Q')).count : 0;

        lostItemChartData.push(
          {
            item : 'Unclaimed',
            count: openLostItems,
          },
          {
            item : 'Claimed',
            count: totalReturned,
          },
          {
            item : 'Disposed',
            count: (lostItemSummary.find(c => c._id === 'T')) ? (lostItemSummary.find(c => c._id === 'T')).count : 0,
          },
          {
            item : 'Donated',
            count: (lostItemSummary.find(c => c._id === 'D')) ? (lostItemSummary.find(c => c._id === 'D')).count : 0,
          },
          {
            item : 'Archived',
            count: (lostItemSummary.find(c => c._id === 'A')) ? (lostItemSummary.find(c => c._id === 'A')).count : 0,
          },
          {
            item : 'Returned',
            count: totalReturned,
          }
         
    
      );





    }


    this.setState({
      claimsSummaryData : claimsChartData,
      openClaims : openClaims,
      readyToShip: readyToShip,
      readyForPickup: readyForPickup,
      lostItemSummaryData : lostItemChartData,
      lostItemPieData : lostItemPieData,
      numReturned : totalReturned,
      RequestToShipCount: RequestToShip,
    });

    if (this.props.updateDashboardWarning){ this.props.updateDashboardWarning(openClaims); };
  }

  

 
  renderBounteBoxImporter =()=>{

    return(
      <Modal open={this.state.showBounteBoxImporter} 
            onClose={()=>this.setState({showBounteBoxImporter:false})} center>
                <BounteBoxImporter style={{width:800, height:600}}  onClose={()=>this.setState({showBounteBoxImporter:false})}>
                                
                </BounteBoxImporter>
      </Modal>
    )


  }

  claimColumns = () =>{
    const claimColumns = [
      { dataField: 'id', hidden:true, text: 'id',headerAlign:'center', headerStyle: (colum, colIndex) => {return { width: '50px', textAlign: 'left' };}},
      { dataField: 'lastName', text: 'Name', headerAlign:'center',classes:'text-info', sort: true,formatter: formatName, textAlign: 'left', events:{
        onClick:(e, column, columnIndex, row, rowIndex)=>{
        this.props.history.push('/Claim/' + row.id);
      }}},

      { dataField: 'status', text: 'Stage',headerAlign:'center',classes:ClaimFormatterFunctions.statusColFormaterClaims, formatter:ClaimFormatterFunctions.formatItemStatusCell, filterable:true, sort: true, textAlign: 'left' },
      { dataField: 'claimDate', text: 'Claim Date',headerAlign:'center',formatter:ClaimFormatterFunctions.formatDate, sort: true, headerStyle: (colum, colIndex) => {return { width: '150px', textAlign: 'center' };} },
     // { dataField: 'details', headerAlign:'center', text: 'Details',sort: true, },
      { dataField: 'lostItemShortDescription', headerAlign:'center', text: 'Details',sort: true, formatter:this.formatDetails },
      { dataField: 'locationLost',sort: true, text: 'Lost Near',style:{cursor: 'pointer'},  headerAlign:'center', textAlign: 'left'},
      { dataField: 'lostItemId', hidden:false,classes:'text-primary',align:'center', text: 'Found Item',sort: true, style:{cursor: 'pointer', width: '100px'},formatter:ClaimFormatterFunctions.formatFoundItemLink},

      { dataField: 'totalMatches', classes:'text-primary text-center',formatter:formatMatched, text: 'Matched',sort: true,headerStyle:{width:'190px', cursor:'hand'}, events:{
          onClick: (e, column, columnIndex, row, rowIndex) => {
                if (row.totalMatches && row.totalMatches > 0){
                  this.props.history.push('/AIM/' + row.id );
                }
          }}},
       
          
    ];

    return claimColumns;
  }

  airlineColums = ()=>{
    const claimColumns = [
      { dataField: 'id', hidden:true, text: 'id',headerAlign:'center', headerStyle: (colum, colIndex) => {return { width: '50px', textAlign: 'left' };}},
      { dataField: 'lastName', text: 'Name', headerAlign:'center',classes:'text-info', sort: true,formatter: formatName, textAlign: 'left', events:{
        onClick:(e, column, columnIndex, row, rowIndex)=>{
        this.props.history.push('/Claim/' + row.id);
      }}},

      { dataField: 'status', text: 'Stage',headerAlign:'center',classes:ClaimFormatterFunctions.statusColFormaterClaims, formatter:ClaimFormatterFunctions.stageFormatter, filterable:true, sort: true, textAlign: 'left' },
      { dataField: 'claimDate', text: 'Claim Date',headerAlign:'center',formatter:ClaimFormatterFunctions.formatDate, sort: true, headerStyle: (colum, colIndex) => {return { width: '150px', textAlign: 'center' };} },

      { dataField: 'lostItemShortDescription', headerAlign:'center', text: 'Details',sort: true, formatter:this.formatDetails },
      { dataField: 'totalMatches', classes:'text-primary text-center',formatter:formatMatched, text: 'Matched',sort: true,headerStyle:{width:'190px', cursor:'hand'}, events:{
          onClick: (e, column, columnIndex, row, rowIndex) => {
                if (row.totalMatches && row.totalMatches > 0){
                  this.props.history.push('/AIM/' + row.id );
                }
          }}},
    ];

    return claimColumns;
  }


  formatDetails=(cell,row)=>{
    if (row.lostItemShortDescription){
      return (<small>{row.lostItemShortDescription}</small>)
    }else{
      return (<small>{row.details}</small>)
    }
  }

 claimRowStyle=(row, rowIndex)=>{
  const style = {};
  if (row.topMatchPct &&  row.topMatchPct> 0) {
   //style.backgroundColor = '#B6D0E2';
   style.borderColor = '#B6D0E2';
   style.borderWidth = 1;
    //return "table-success";
  } else {
    //style.backgroundColor = '#dbf2e3';
  }

  
  return style;
 }


  renderClaimGrid=()=>{
    return (

      <div>
       
   
   

        <ToolkitProvider 
        bootstrap4
          keyField='id' 
          data={ this.state.recentOpenClaims } 
          columns={ 
            this.getClaimColumns(this.state.venueTypeCd)  } 
           
          
         
          
          
          >
          {
    props => (
      <div>
       

        <BootstrapTable
         className="table-sm"
          striped
          hover
          condensed
          rowEvents={this.claimRowEvents}
          rowStyle={ this.claimRowStyle }
          { ...props.baseProps }
         
        />
      </div>
    )
  }</ToolkitProvider>

      </div>


    )

    
  }
  renderLostItemGrid=()=>{
    return (

      <div >
       
       
       {this.renderToast()}
       {this.state.filteredItems === null && <p>Loading lostItems...</p>}
        <ToolkitProvider 
        bootstrap4
          keyField='id' 
          data={ this.state.recentLostItems } 
         
          columns={ this.getColumns(this.state.venueTypeCd) } 
          defaultSorted={defaultSorted}
         
          >
          {
    props => (
      <div>
       

        <BootstrapTable
         className="table-sm"
          striped
          hover
          condensed
          rowEvents={this.rowLostItemEvents}
          
          { ...props.baseProps }
         
        />
      </div>
    )
  }</ToolkitProvider>

      </div>


    )

    
  }


  renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
  }

  renderBoxCountDashboardItem =()=>{
    if (this.state.hasBounteBoxActive){
      return (
        <div className='col-sm'>
        <div className="card bg-light mb-3">
          <div className="card-header"> New Express QR Item(s) </div>
          <div className="card-body" style ={{textAlign: 'center'}}> 
          <h2 style ={{textAlign: 'center'}}> 
              <Link className="text-danger" to="#"  onClick={()=>{this.setState({showBounteBoxImporter:true})}} >{this.state.bounteBoxItemsCount}</Link></h2>
              <p className="card-text"> </p>

            
          </div>
        </div>
      </div>
      )
    }
  }

  renderReleasePendingItems =()=>{
                //
                return (

                  <div >
                  
                  
                  {this.renderToast()}
                  {this.state.filteredItems === null && <p>Loading Pending Released Items...</p>}
                    <ToolkitProvider 
                    bootstrap4
                      keyField='id' 
                      data={ this.state.pastDueReleaseDateItems } 
                    
                      columns={ lostItemReleasePendingColumns} 
                      defaultSorted={defaultSorted}
                    
                      >
                      {
                props => (
                  <div>
                  

                    <BootstrapTable
                    className="table-sm"
                      striped
                      hover
                      condensed
                      rowEvents={this.rowLostItemEvents}
                      
                      { ...props.baseProps }
                      pagination={ paginationFactory(paginationOption) }
                    />
                  </div>
                )
                }</ToolkitProvider>

                  </div>


                )

  }

  renderTabAndChartSection=()=>{
    if (this.state.venueTypeCd==='A' || this.state.displayReleaseDateOnDashboard===true){
      return (
        <Tabs>
        <TabList>
              <Tab><p className='text-info'><b>Pending Release</b></p></Tab>
              <Tab><p className='text-info'><b>Claim Summary</b></p></Tab>
        </TabList>
        <TabPanel>
              {this.renderReleasePendingItems()}
        </TabPanel>
        <TabPanel>
            <VictoryChart  domainPadding={20}>
                <VictoryLabel text="Claim Status Summary" x={225} y={30} textAnchor="middle"/>
                    <VictoryBar
                      
                      data={this.state.claimsSummaryData}
                  
                  // data accessor for x values
                  //x="item"
                  // data accessor for y values
                  //y="count"
                
  
                />
                <VictoryAxis label="Status" style={{tickLabels: { fontSize: 9}}}/>
                <VictoryAxis dependentAxis
                    label="# Claims"
                    tickFormat={(v) => Math.round(v)}/////
                    style={{
                      axisLabel: { padding: 35 }
                    }}
                  />
            </VictoryChart>
        </TabPanel>
  </Tabs>
      )
    }else{
      return (
       
            <VictoryChart  domainPadding={20}>
                <VictoryLabel text="Claim Status Summary" x={225} y={30} textAnchor="middle"/>
                    <VictoryBar
                      
                      data={this.state.claimsSummaryData}
                  
                  // data accessor for x values
                  //x="item"
                  // data accessor for y values
                  //y="count"
                
  
                />
                <VictoryAxis label="Status" style={{tickLabels: { fontSize: 9}}}/>
                <VictoryAxis dependentAxis
                    label="# Claims"
                    tickFormat={(v) => Math.round(v)}/////
                    style={{
                      axisLabel: { padding: 35 }
                    }}
                  />
            </VictoryChart>
        
      )
    }
    
  }
  render() {
    return (
      <div className="w-100 p-3">
        <h3>DASHBOARD </h3>
        {this.renderToast()}
        <div >






          <div className='row'>
            <div className='col-sm'>
              <div className="card bg-light mb-3">
                <div className="card-header"> Open Claims</div>
                <div className="card-body">
                  <h2 style ={{textAlign: 'center'}}> <Link className="text-danger"  to="/FilteredClaims/O"  >{this.state.openClaims}</Link></h2>
                  <p className="card-text"> </p>
                </div>
              </div>
            </div>
            <div className='col-sm'>
              <div className="card bg-light mb-3">
                <div className="card-header"> Claims With Matches</div>
                <div className="card-body">
                  <h2 style ={{textAlign: 'center'}}> <Link className="text-info"  to="/AIM"  >{this.state.matchedItemCount}</Link></h2>
                  <p className="card-text"> </p>
                </div>
              </div>
            </div>
            <div className='col-sm'>
              <div className="card bg-light mb-3">
                <div className="card-header">Ready to Ship</div>
                <div className="card-body">

                   <h2 style ={{textAlign: 'center'}}> <Link className="text-warning" to="/FilteredClaims/READYTOSHIP"  >{this.state.readyToShip}</Link></h2>
                  <p className="card-text"></p>
                </div>
              </div>
            </div>
        
             <div className='col-sm'>
              <div className="card bg-light mb-3">
                <div className="card-header">Will Pickup In-person</div>
                <div className="card-body">

                   <h2 style ={{textAlign: 'center'}}> <Link className="text-warning" to="/FilteredClaims/WP"  >{this.state.readyForPickup}</Link></h2>
                  <p className="card-text"></p>
                </div>
              </div>
            </div>
            {this.renderBoxCountDashboardItem()}
            <div className='col-sm'>
              <div className="card bg-light mb-3">
                <div className="card-header"> Returned</div>
                <div className="card-body">
                <h2 style ={{textAlign: 'center'}}> <Link className="text-success"  to="/FilteredLostItems/R"  >{this.state.numReturned}</Link></h2>
                  <p className="card-text"> </p>
                </div> 
              </div>
            </div>

            <div className='col-sm'>
              <div className="card bg-light mb-3">
                <div className="card-header"> Request To Ship</div>
                <div className="card-body">
                <h2 style ={{textAlign: 'center'}}> <Link className="text-warning"  to="/FilteredClaims/REQUESTTOSHIP"  >{this.state.RequestToShipCount}</Link></h2>
                  <p className="card-text"> </p>
                </div> 
              </div>
            </div>
          </div>
         

         <div className='row'>
            <div className='col-12'>
                <h5>CLAIMS: 10 Most Recent</h5>
            </div>
          </div>

         <div className='row'>
            <div className='col-8'>
                {this.renderClaimGrid()}
            </div>
            
            <div className='col-4'>
                {this.renderTabAndChartSection()}
           
              </div>
          </div>


         <div className='row'>
            <div className='col-12'>
                <h5>Found Items: 10 Most Recent</h5>
            </div>
          </div>
            <div className='row'>
            <div className='col-8'>
                {this.renderLostItemGrid()}
              </div>
              <div className='col-4'>
              <VictoryChart  domainPadding={20} >
                  <VictoryLabel text="Lost Item Status Summary" x={225} y={30} textAnchor="middle"/>
                  <VictoryBar
                  style={this.state.lostStyle}

                      data={this.state.lostItemSummaryData}
                      // data accessor for x values
                      x="item"
                      // data accessor for y values
                      y="count"
                    />
                    <VictoryAxis label="Status" style={{tickLabels: {fontSize: 9}}}/>
                    <VictoryAxis dependentAxis
                      label="# Items"
                      tickFormat={(v) => Math.round(v)}
                      style={{
                        axisLabel: { padding: 40 }
                        

                      }}
                    />
                    </VictoryChart>
            </div>


          </div>



        

        </div>
       {this.renderBounteBoxImporter()}
    </div>
      
    )
  }
}

export default withRouter(Dashboard);